'use client'

import dynamic from 'next/dynamic'
import { type ComponentType } from 'react'
import { OverScreen } from './niceModalReact'
import { type OverScreenIds } from './types'

export type OverScreenLoader = () => Promise<{ default: ComponentType<any> }>

export const registerOverScreens = (loaders: Record<OverScreenIds, OverScreenLoader>): void => {
  ;(Object.keys(loaders) as OverScreenIds[]).forEach((id) => {
    const Component = dynamic(loaders[id], { ssr: false })
    OverScreen.register(id, Component)
  })
}
